const aresDossier = require('./aresDossier');
const contractInit = require('./commons/contractInit');
const contractAresLoan = require('./contracts/contractAresLoan');
const contractEasyLoan = require('./contracts/contractEasyLoan');
const contractEasyLoanTypeC = require('./contracts/contractEasyLoanTypeC');
const contractPayrollLoan = require('./contracts/contractPayrollLoan');
const contractPreGrantedCredit = require('./contracts/contractPreGrantedCredit');
const contractRetailLoan = require('./contracts/contractRetailLoan');
const loanModifyAssociatedAccount = require('./loanModifyAssociatedAccount');
const loansMovements = require('./loansMovements');
const loanPartialAmortization = require('./loanPartialAmortization');
const loanRepaymentPlan = require('./loanRepaymentPlan');
const loanSettlements = require('./loanSettlements');
const loans = require('./loans');
const payrollLoanRequest = require('./contracts/payrollLoanRequest');
const loanRecordStatus = require('./loanRecordStatus');
const mortgageAssociatedInsurances = require('./mortgageAssociatedInsurances');
const segmentedLoanProducts = require('./segmentedLoanProducts');

module.exports = {
    aresDossier,
    contractAresLoan,
    contractEasyLoan,
    contractEasyLoanTypeC,
    contractInit,
    contractPayrollLoan,
    contractPreGrantedCredit,
    contractRetailLoan,
    loanModifyAssociatedAccount,
    loansMovements,
    loanPartialAmortization,
    loanRecordStatus,
    loanRepaymentPlan,
    loanSettlements,
    loans,
    payrollLoanRequest,
    mortgageAssociatedInsurances,
    segmentedLoanProducts
};
